import { useEffect, useState } from "react";
import client from "../lib/api";

/**
 * PresenceLine.
 *
 * A one-sentence, cumulative, gap-forgiving line under the pledge
 * card. Never a streak, never a consecutive count. Klair's voice:
 * a sentence, not a scoreboard.
 *
 *   "you've shown up 6 times and closed 2 milestones since you started"
 */
export function PresenceLine({ pledgeId }) {
  const [presence, setPresence] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!pledgeId) return () => { alive = false; };
    client.get(`/accountability/pledge/${pledgeId}/presence`)
      .then((r) => { if (alive) setPresence(r.data); })
      .catch(() => { if (alive) setPresence(null); });
    return () => { alive = false; };
  }, [pledgeId]);

  if (!presence) return null;

  const times = presence.shown_up;
  const closed = presence.milestones_closed;
  let sentence;
  if (times === 0 && closed === 0) {
    sentence = "your pledge is ready when you are, since you started";
  } else if (closed === 0) {
    sentence = `you've shown up ${times} time${times === 1 ? "" : "s"} since you started`;
  } else if (times === 0) {
    sentence = `you've closed ${closed} milestone${closed === 1 ? "" : "s"} since you started`;
  } else {
    sentence = `you've shown up ${times} time${times === 1 ? "" : "s"} and closed ${closed} milestone${closed === 1 ? "" : "s"} since you started`;
  }

  return (
    <div className="k-quiet mt-3 klareet-serif" style={{ fontSize: "0.9rem" }} data-testid="pledge-presence-line">
      {sentence}
    </div>
  );
}
